<template>
    <div :class="{bg_custom:customPosition,axa_bg_size:overrideSize}" class="caption round-medium bottom-10 card" :style="loadBgImage">
        
        <div v-if="customContent" :style="loadUpperBg">
            <div class="ipad-display">
                <div v-if="textImageDesk">
                    <img v-bind:src="'images/mpower-new/about/'+textImageDesk" class="img-resize ipad" :style="customBgColor">
                </div>
                <div v-else>
                    <img v-bind:src="'images/mpower-new/about/'+textImage" class="img-resize mobile" :style="customBgColor">
                </div>
            </div>
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/about/'+textImage" class="img-resize" :style="customBgColor">
            </div>
        </div>
        <div v-else>
            <div class="ipad-display">
                <div v-if="textImageDesk">
                    <img v-bind:src="'images/mpower-new/about/'+textImageDesk" class="img-resize ipad" :style="customBgColor">
                    <div v-if="customPosition" class="responsive-iframe">
                        <video width="65%" controls onloadedmetadata="this.muted = true" playsinline autoplay muted loop class="rounded">
                            <source :src="'images/mpower-new/about/our_history/video.mp4'" type="video/mp4">
                        </video>
                    </div>
                    <div v-if="customText" class="responsive-iframe">
                        <a target="_blank" href="https://www.generali.com.my" >
                            <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/website.png" />
                            <div class="img-link">
                                https://www.generali.com.my
                            </div>  
                        </a>
                        <a target="_blank" href="https://www.facebook.com/GeneraliMalaysia" >
                            <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/facebook.png" />
                            <div class="img-link">
                                https://www.facebook.com/GeneraliMalaysia
                            </div>   
                        </a>
                        <a target="_blank" href="https://www.instagram.com/generalimalaysia/" >
                            <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/instagram.png" />
                            <div class="img-link">
                                https://www.instagram.com/generalimalaysia/
                            </div>  
                        </a>
                        <a target="_blank" href="https://www.youtube.com/@generalimalaysia" >
                            <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/youtube.png" />
                            <div class="img-link">
                                https://www.youtube.com/@generalimalaysia
                            </div>  
                        </a>
                        <a target="_blank" href="https://www.linkedin.com/company/generali-malaysia" >
                            <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/linkedin.png" />
                            <div class="img-link">
                                https://www.linkedin.com/company/generali-malaysia
                            </div>  
                        </a>
                    </div>
                </div>
                <div v-else>
                    <img v-bind:src="'images/mpower-new/about/'+textImage" class="img-resize mobile" :style="customBgColor">
                </div>
            </div>
            <div class="mobile-display">
                <img v-bind:src="'images/mpower-new/about/'+textImage" class="img-resize" :style="customBgColor">
                <div v-if="customPosition" class="responsive-iframe">
                    <video width="80%" controls onloadedmetadata="this.muted = true" playsinline autoplay muted loop class="rounded">
                        <source :src="'images/mpower-new/about/our_history/video.mp4'" type="video/mp4">
                    </video>
                </div>
                <div v-if="customText" class="responsive-iframe">
                    <a target="_blank" href="https://www.generali.com.my" >
                        <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/website.png" />
                        <div class="img-link">
                            https://www.generali.com.my
                        </div>  
                    </a>
                    <a target="_blank" href="https://www.facebook.com/GeneraliMalaysia" >
                        <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/facebook.png" />
                        <div class="img-link">
                            https://www.facebook.com/GeneraliMalaysia
                        </div>  
                    </a>
                    <a target="_blank" href="https://www.instagram.com/generalimalaysia/" >
                        <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/instagram.png" />
                        <div class="img-link">
                            https://www.instagram.com/generalimalaysia/
                        </div>  
                    </a>
                    <a target="_blank" href="https://www.youtube.com/@generalimalaysia" >
                        <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/youtube.png" />
                        <div class="img-link">
                            https://www.youtube.com/@generalimalaysia
                        </div>  
                    </a>
                    <a target="_blank" href="https://www.linkedin.com/company/generali-malaysia" >
                        <img class="img-icon" src="images/mpower-new/about/about_generali/iPad/custom/linkedin.png" />
                        <div class="img-link">
                            https://www.linkedin.com/company/generali-malaysia
                        </div>  
                    </a>
                </div>
            </div>
        </div>
        <div v-if="customContent" class="img-text">

            <div class="ipad-display">
                <a target="_blank" href="https://www.axa.com.my" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/axa-logo.png" />
                </a>
                <a target="_blank" href="https://www.linkedin.com/company/axa-affin-insurance-malaysia" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/In_icon.png" />
                </a>
                <a target="_blank" href="https://twitter.com/MYAXAAffin" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/Twitter_icon.png" />
                </a>
                <a target="_blank" href="https://www.facebook.com/MYAXAAffin/" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/fb_icon.png" />
                </a>
                <a target="_blank" href="https://www.instagram.com/myaxaaffin/" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/Insta_icon.png" />
                </a>
                <a target="_blank" href="https://www.youtube.com/channel/UCqg82_j_2SvEItvDPDmDAAA" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/youtube_icon.png" />
                </a>
            </div>
            <div class="margin-bottom-90 mobile-display">
                <a target="_blank" href="https://www.axa.com.my" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/axa-logo.png" />
                </a>
                <a target="_blank" href="https://www.linkedin.com/company/axa-affin-insurance-malaysia" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/In_icon.png" />
                </a>
                <a target="_blank" href="https://twitter.com/MYAXAAffin" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/Twitter_icon.png" />
                </a>
            </div>
            <div class="mobile-display">
                <a target="_blank" href="https://www.facebook.com/MYAXAAffin/" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/fb_icon.png" />
                </a>
                <a target="_blank" href="https://www.instagram.com/myaxaaffin/" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/Insta_icon.png" />
                </a>
                <a target="_blank" href="https://www.youtube.com/channel/UCqg82_j_2SvEItvDPDmDAAA" class="img-wrapper">
                    <img class="img-icon" src="images/mpower/get_to_know_us_slide/youtube_icon.png" />
                </a>
            </div>
        </div>
        <div class="top-bar" :style="loadBar"></div>
    </div>
</template>
<style scoped>

.responsive-iframe{
    z-index: 999;
    top: 25%;
    position: absolute;
    width: 100%;
}
.rounded {
    border-radius: 20px; 
    overflow: hidden;
    -webkit-transform: translateZ(0);
}
.mb-60 {
    margin-bottom: 60px;
}
.img-resize {
    max-width: 768px;
    max-height: 100%;
  
}
.img-icon {
    height: 33.6px;
    width: 33.6px !important;
    margin: 10px 20px !important;
    display: unset !important;
    /* margin-right: 20px; */
}

.img-link{
    display: inline-flex !important;
    vertical-align: top;
    line-height: 55px;
    width: 410px;
    font-size: 17px;
    color: #7A7B7A;
   
}

.mobile-display .img-wrapper {
    width: 33.33%;
    float: left;
}
.ipad-display .img-wrapper {
    width: 16%;
    float: left;
}
.bg_custom {
    background-size: cover;
    background-repeat: no-repeat;
}
@media (max-width: 765px){
    .responsive-iframe{
        top: 30%;
    }
    .img-icon {
        height:20px;
        width: 20px !important;
        margin: 5px 10px !important;
    }

    .img-link{
        line-height: 29px;
        width: 290px;
        font-size: 12px;
    }
}
@media (max-width: 575px){
    /*.img-resize{
        max-width: 100% !important;
    }*/
    .bg_custom {
        background-position: 25% !important;
    }
}

@media (max-width: 480px){

    .img-link{
        display: inline-flex !important;
        vertical-align: top;
        line-height: 35px;
        width: 270px;
        font-size: 11px;
        color: #7A7B7A;
    
    }

    .img-link{
        line-height: 29px;
    }
}


.img-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: rgba(47,111,126);
    z-index: 99;
    width: 100%;
    padding: 30px 0 60px 0;
    background: #fff;
}
</style>
<script>
export default {
    name: 'SliderIntroWithBg',
    props: {
        bgImage: String,
        bgColor: String,
        bgImageDesk: String,
        textImage: String,
        textImageDesk: String,
        customPosition: Boolean,
        bar: String,
        customContent: Boolean,
        customText: Boolean,
        overrideSize: Boolean
    },
    computed: {
        loadBgImage() {
            if(this.customPosition==true){
                return {
                    'backgroundImage':'url(\'images/mpower-new/about/' + this.bgImage + '\')',
                }
            }
            else{
                var w=window.innerWidth;

                if(w>765 && this.bgImageDesk){
                    return {
                        'backgroundImage':'url(\'images/mpower-new/about/' + this.bgImageDesk + '\')',
                        'background-size': 'cover',
                        'background-repeat': 'no-repeat',
                        'background-position': 'center',
                    }
                }else{
                    return {
                        'backgroundImage':'url(\'images/mpower-new/about/' + this.bgImage + '\')',
                        'background-size': 'cover',
                        'background-repeat': 'no-repeat',
                        'background-position': 'center',
                    }
                }
            }
        },
        loadUpperBg(){
            return {
                'backgroundImage':'url(\'images/mpower/get_to_know_us_slide/KLCC.png\')',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
                'background-position': 'center',
            }
        },
        loadBar() {
            return {
                'background': this.bar,
                'opacity': '88%'
            }
        },
        customBgColor(){
            return {
                'background-color': this.bgColor
            }
        }
    }
}
</script>
